"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const AntBoardLoader_1 = require("../../../problems/santa-fe/AntBoardLoader");
const CGPGenerator_1 = require("../../../cgp/CGPGenerator");
const CGPPointMutator_1 = require("../../../cgp/CGPPointMutator");
const RecurrentCGPExecutor_1 = require("../../../cgp/RecurrentCGPExecutor");
exports.default = () => {
    const cgpConfig = {
        numInputs: 2,
        numMiddleNodes: 100,
        numOutputs: 2,
        nodeInputCount: 2,
        operators: [
            ([x, y]) => {
                return x && y;
            },
            ([x, y]) => {
                return x || y;
            },
            ([x, y]) => {
                return x && !y;
            },
            ([x, y]) => {
                return x !== y;
            },
            ([x, y]) => {
                return !x;
            },
        ],
    };
    const generator = new CGPGenerator_1.CGPGenerator(cgpConfig);
    const mutator = new CGPPointMutator_1.CGPPointMutator(cgpConfig);
    const pool = Array.from({ length: 5 }, (_, i) => generator.generate());
    //let parent = pool[0];
    const [antBoard, setAntBoard] = React.useState(null);
    const [bestScore, setBestScore] = React.useState(0);
    const [parent, setParent] = React.useState(pool[0]);
    const [generation, setGeneration] = React.useState(1);
    function runGenerations(board, count) {
        return __awaiter(this, void 0, void 0, function* () {
            let i = 0;
            let localParent = parent;
            let localGeneration = generation;
            (function run() {
                return __awaiter(this, void 0, void 0, function* () {
                    // Nice part is we already have the fitnesses:
                    pool[0] = localParent;
                    for (let i = 1; i < pool.length; i++) {
                        pool[i] = mutator.mutate(localParent);
                    }
                    let currentPoolBest = 0;
                    for (let i = 0; i < pool.length; i++) {
                        board.reset();
                        const executor = new RecurrentCGPExecutor_1.RecurrentCGPExecutor(pool[i], cgpConfig, false, true);
                        for (let turn = 0; turn < 400; turn++) {
                            const input = executor.execute(board.getState());
                            board.executeAction(input[0], input[1]);
                        }
                        const score = board.foodGathered;
                        if (score >= currentPoolBest) {
                            currentPoolBest = score;
                            localParent = pool[i];
                            setParent(pool[i]);
                        }
                    }
                    setBestScore(currentPoolBest);
                    localGeneration++;
                    setGeneration(localGeneration);
                    i++;
                    if (i < count) {
                        setTimeout(run, 0);
                    }
                    else {
                    }
                });
            })();
        });
    }
    function renderControls(board) {
        return (React.createElement("div", null,
            "Best score: ",
            bestScore,
            "Generation: ",
            generation,
            React.createElement("br", null),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    runGenerations(board, 1);
                }) }, "Run 1 generation"),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    runGenerations(board, 100);
                }) }, "Run 100 generations"),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    runGenerations(board, 1000);
                }) }, "Run 1000 generations")));
    }
    function renderAntBoard(board) {
        return (React.createElement("div", null,
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    const tempBoard = board.reset();
                    setAntBoard(Object.create(tempBoard));
                    const executor = new RecurrentCGPExecutor_1.RecurrentCGPExecutor(parent, cgpConfig, false, true);
                    let frameCount = 0;
                    let lastUpdate = Date.now();
                    const render = () => {
                        if (Date.now() - lastUpdate > 200) {
                            lastUpdate = Date.now();
                            frameCount++;
                            const input = executor.execute(tempBoard.getState());
                            tempBoard.executeAction(input[0], input[1]);
                            setAntBoard(Object.create(tempBoard));
                        }
                        if (board.turns < 400)
                            window.requestAnimationFrame(render);
                    };
                    render();
                }) }, "Play best program"),
            "Ant is facing: ",
            board.antDirection,
            ". Food: ",
            board.foodGathered,
            ". Turn: ",
            board.turns,
            ".",
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    const tempBoard = board.reset();
                    setAntBoard(Object.create(tempBoard));
                }) }, "Reset"),
            " ",
            React.createElement("br", null),
            board.currentBoard.map((row, i) => (React.createElement("div", null, row.map((cell, j) => (React.createElement("span", null,
                board.antPosition[0] === i && board.antPosition[1] === j
                    ? "A"
                    : cell
                        ? "X"
                        : ".",
                " "))))))));
    }
    return (React.createElement("div", null,
        React.createElement("p", null, "So, I think there's a better way to implement RCGP than the way I implemented it."),
        React.createElement("p", null, "In the previous implementation, a node could only refer to previous states. This was to avoid circular dependencies, but came at the cost that input would be \"delayed\" based on how long the chain between input/output was."),
        React.createElement("p", null, "To counteract this, I'm going to try a different implementation, where if a reference is \"to the left\", use the actual output value. Otherwise, use the last state."),
        antBoard === null && (React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                const board = yield (0, AntBoardLoader_1.loadFromUrl)("/data/santa-fe-ant-trail.csv");
                setAntBoard(board);
            }) }, "Load Trail")),
        antBoard !== null && renderControls(antBoard),
        antBoard !== null && renderAntBoard(antBoard)));
};
